let ytVideoAllowed = false;
let spotifyPodcastAllowed = false;

window.addEventListener("ucEvent", function(e) {
    if (e.detail && e.detail.event === "consent_status") {
        ytVideoAllowed = e.detail.hasOwnProperty('YouTube Video') && e.detail["YouTube Video"] === true;
        spotifyPodcastAllowed = (e.detail.hasOwnProperty('Spotify') && e.detail["Spotify"] === true)
            || (e.detail.hasOwnProperty('anchor.fm') && e.detail["anchor.fm"] === true);
        embedVideoBox();
        embedPodcastBox();

        const newsletterUCKey = 'Mailchimp';
        const newsletterAllowed = e.detail.hasOwnProperty(newsletterUCKey) && e.detail[newsletterUCKey] === true;
        window._header.setNewsletterCookiesState(newsletterAllowed);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    embedVideoBox();
    embedPodcastBox();
});

function embedVideoBox() {
    document.querySelectorAll('.youtube_iframe').forEach(function($box) {
        if (ytVideoAllowed) {
            $box.querySelector('.embed-video-box-no-cookies').style.display = 'none';
            $box.insertAdjacentHTML('beforeend', embedVideoYtCode($box.dataset.id, $box.dataset));
        } else {
            $box.querySelector('.embed-video-box-no-cookies').style.display = 'block';
            let iframe = $box.querySelector('iframe');
            if (iframe) {
                iframe.remove();
            }
        }
    });
}

function embedPodcastBox() {
    document.querySelectorAll('.anchor_fm_iframe').forEach(function($box) {
        if (spotifyPodcastAllowed) {
            $box.querySelector('.embed-podcast-box-no-cookies').style.display = 'none';
            $box.insertAdjacentHTML('beforeend', embedPodcastCode($box.dataset.src, $box.dataset));
        } else {
            $box.querySelector('.embed-podcast-box-no-cookies').style.display = 'block';
            let iframe = $box.querySelector('iframe');
            if (iframe) {
                iframe.remove();
            }
        }
    });
}

function embedVideoYtCode(id, data) {
    let attributes = Object.keys(data)
        .filter(key => key !== 'id')
        .map(key => `${key}="${data[key]}"`)
        .join(' ');
    return '<iframe data-usercentrics="YouTube Video" src="https://www.youtube-nocookie.com/embed/' + id + '" ' + attributes +'></iframe>';
}

function embedPodcastCode(src, data) {
    let attributes = Object.keys(data)
        .filter(key => key !== 'src')
        .map(key => `${key}="${data[key]}"`)
        .join(' ');
    return '<iframe data-usercentrics="Spotify" scrolling="no" src="' + src + '" ' + attributes +'></iframe>';
}
